import { useSelector } from 'react-redux';

import { getCurrentCity } from '@r1-frontend/entities/stores/city/selectors';

const SeoOrganizationScript = () => {
    const { callCenter, cityIn, companyName, domain, legalEntity, logoFull, name } = useSelector(getCurrentCity);

    return (
        <script
            id={'organizationInfo'}
            type={'application/ld+json'}
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    'name': `Интернет-провайдер ${companyName}`,
                    'legalName': `${legalEntity}`,
                    'url': `https://${domain}.dom.ru/`,
                    'logo': `${logoFull}`,
                    'description': `Провайдер интернета и цифрового телевидения ${companyName} в ${cityIn}`,
                    'address': {
                        '@type': 'PostalAddress',
                        'addressLocality': `${name}`,
                        'addressCountry': 'RU',
                    },
                    'contactPoint': {
                        '@type': 'ContactPoint',
                        'telephone': `${callCenter}`,
                        'contactType': 'customer service',
                        'areaServed': 'RU',
                        'availableLanguage': 'Russian',
                    },
                }),
            }}
        />
    );
};

export default SeoOrganizationScript;
